import de from "date-fns/esm/locale/de/index.js";
const dateDeDE = {
  name: 'de-DE',
  locale: de
};
export default dateDeDE;